import React from "react"
import { VStack, Text, HStack, Button, Avatar } from "@chakra-ui/react"
import { AddIcon, MinusIcon } from "@chakra-ui/icons"

const MemberList = ({
  members,
  membersTopToolbar,
  handleAddMember,
  handleRemoveMember,
  selectedTeamId,
  membersBottomToolbar,
}) => {
  return (
    <VStack>
      {membersTopToolbar}
      <VStack
        align="stretch"
        spacing={2}
        width="100%"
        bg="white"
        borderRadius="0.75em"
        boxShadow="lg"
        height="100%"
        padding="0.75em"
      >
        {Array.isArray(members) &&
          members.map((member) => (
            <HStack key={member.id} justifyContent="space-between">
              <HStack>
                <Avatar bg="Primary.500" height="1.25em" width="1.25em" />
                <Text>{member.email}</Text>
              </HStack>
              <Button
                maxH="1.25em"
                maxW="1.25em"
                minH="1.25em"
                minW="1.25em"
                padding="0"
                bg={
                  member.in_team.includes(selectedTeamId)
                    ? "red.500"
                    : "blue.500"
                }
                color="white"
                isDisabled={!selectedTeamId}
                onClick={() =>
                  member.in_team.includes(selectedTeamId)
                    ? handleRemoveMember(member)
                    : handleAddMember(member)
                }
              >
                {member.in_team.includes(selectedTeamId) ? (
                  <MinusIcon />
                ) : (
                  <AddIcon />
                )}
              </Button>
            </HStack>
          ))}
      </VStack>
      {membersBottomToolbar}
    </VStack>
  )
}

export default MemberList
